import { ClassificationFeature } from "./ClassificationFeature";

export class ClassificationClass {

  constructor(
    public id?: string,
    public classificationSystemId?: string,
    public parentId?: string,
    public name?: string,
    public number?: string,
    public text?: string,
    public order?: number,
    public assignable?: boolean,
    public features?: ClassificationFeature[]
  ) {
  }
}


